<template>
    <div id="forgetPsd">
        <div class="forgetPsd_main  pubw">
            <div class="form">
                <h2>忘記密碼</h2>
                <el-form hide-required-asterisk :model="forgetPsdForm" :rules="forgetPsdRuleForm" ref="emailForm">
                    <el-form-item label="電郵" prop="mail">
                      <el-input v-model="forgetPsdForm.email"></el-input>
                    </el-form-item>
                </el-form>
                <el-form hide-required-asterisk :model="forgetPsdForm" :rules="forgetPsdRuleForm" ref="forgetPsdRuleForm">
                    <el-form-item prop="verify">
                        <div class="code_input">
                             <el-input placeholder="验证码" v-model="forgetPsdForm.verify">
                          </el-input>
                          <SendCodeBtn :callback="sendCode" :emailForm="emailValid"/></SendCodeBtn>
                        </div>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input type="password" placeholder="密碼" v-model="forgetPsdForm.password"></el-input>
                      </el-form-item>
                </el-form>
                <optionsButton class="forgetPsd" title="登入" :callback="forgetPsd"/>
                <div class="regitster" @click="login">登入</div>
            </div>
        </div>
    </div>
</template>

<script>
  // 引入组件
  import optionsButton from '@/components/optionButton'
  import SendCodeBtn from '@/components/SendCodeBtn'
  import { Loading } from 'element-ui';
export default {
    name:'forgetPsd',
    inject:["reloadAll"],
    components:{
        optionsButton,
        SendCodeBtn
    },
    data(){
        // 验证邮箱正则
        let checkEamil = (rule,value,callback)=>{
            // const regEmail = /^([a-zA-Z0-9_-])+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-])+/
            // const regEmail=/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/;
            const regEmail = /^[A-Za-z0-9/.]+@+[A-Za-z0-9*]+[/.A-Za-z0-9]*$/
            if(!regEmail.test(value)) return callback(new Error('請輸入正確的電郵格式!'))
            return callback()
        }
        return {
            // 登录表单信息
            forgetPsdForm:{
                email:'',
                verify: '',
                password:'',
            },
            // 登录表单规则
            forgetPsdRuleForm:{
                email:[
                { required: true, message: '請輸入電子郵箱', trigger: 'blur' },
                {validator:checkEamil,trigger:'blur'}  
                // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                verify:[
                { required: true, message: '* 請填寫验证码。', trigger: 'blur' },
                ],
                password:[
                { required: true, message: '請輸入密碼', trigger: 'blur' },
                // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        // 监听用户点击登录按钮
        forgetPsd(){
            this.$refs.forgetPsdRuleForm.validate(async valid =>{
                if(!valid) return
                let loadingInstance = Loading.service();
                // 发送登录请求
                let res = await this.$http.post(`app/login/resetPassByEmail?email=${this.forgetPsdForm.email}&password=${this.forgetPsdForm.password}&verify=${this.forgetPsdForm.verify}`)
                console.log(res, '修改密码结果')
                if(res.data.success){
                    this.$message.success("修改密碼成功")
                    loadingInstance.close();
                    this.$router.push('/login')
                }else{
                    this.$message.error("修改密碼失敗")
                    loadingInstance.close();
                }
                // this.$router.push('/login')
            })
        },
        // 监听用户点击发送验证码
        async sendCode(){
            let email = this.forgetPsdForm.email
            let loadingInstance = Loading.service();
            let res = await this.$http.post(`app/login/resetEmail?email=${email}`)
            console.log(res)
            if(!res.data.success){
                    loadingInstance.close();
                this.$message.error(res.data.message)
                return false  
            }
            if(res.data.success){
                loadingInstance.close();
                this.$message.success("發送成功")
            }
            return true
        },
        // 监听用户点击登录
        login(){
            this.$router.push('/login')
        },
        // 判断是否可以发送验证码
        emailValid(){
            return this.$refs.emailForm
        }
    },
}
</script>

<style lang="less">
    #forgetPsd{
        background-color: #f4f4f4;
        .forgetPsd_main{
            display: flex;
            height: 698.18px;
            align-items: center;
            margin:0 auto;
            .form{
                h2{
                    font-size: 30px;
                    margin-bottom:50px;
                    font-weight:550;
                }
                .regitster{
                    width: fit-content;
                    text-align: center;
                    border-bottom:2px solid @colorMain;
                    padding-bottom:5px;
                    font-size: 18px;
                    color: @colorMain;
                }
                .regitster:hover{
                    cursor: pointer;
                }
                .el-input__inner{
                    width: 390px;
                    height: 56px;
                    border-radius: 12px;
                }
                .el-input__inner:focus{
                    border-color: @colorMain !important;
                }
                .forgetPsd{
                    width: 390px;
                    margin: 15px 0;
                }
                .forget{
                    color: #A7A7A7;
                    font-size: 13px;
                    margin:15px 0 30px  ;
                }
                .forget:hover{
                    cursor: pointer;
                }
                .code_input{
                    width: 390px;
                    display: flex;
                    justify-content: space-between;
                    .el-input__inner{
                        border-color: #c0c4cc;
                        width: 80%;
                        margin-right:0px;
                    }
                    .el-input-group__append{
                        border: 1px solid #DCDFE6;
                    }
                    button{
                        width: 20%;
                        text-align: center;
                    }
                }
            }
        }
    }
</style>